<div class="dedicate-location">
    <div id="map" class="map" leaflet [leafletOptions]="mapOptions" (leafletMapReady)="onMapReady($event)">
    </div>
    <div class="panel samim">
        <div *ngIf="done" class="message done">{{ 'DEDICATE_LOCATION_DONE' | translate }}</div>
        <ng-container *ngIf="!done && ready">
            <div class="hint">{{ 'DEDICATE_LOCATION_HINT' | translate }}</div>
            <ng-container *ngIf="!linkToken">
                <select class="form-control form-control-sm" [(ngModel)]="contact.person_type_fa">
                    <option value="حقیقی">حقیقی</option>
                    <option value="حقوقی">حقوقی</option>
                </select>
                <input class="form-control form-control-sm" type="text" maxlength="80" [(ngModel)]="contact.name"
                    [placeholder]="('NAME' | translate) + ' *'">
                <input class="form-control form-control-sm" type="text" maxlength="80" [(ngModel)]="contact.family"
                    [placeholder]="'FAMILY' | translate">
                <input *ngIf="contact.person_type_fa == 'حقوقی'" class="form-control form-control-sm" type="text"
                    maxlength="120" [(ngModel)]="contact.company_name" [placeholder]="'COMPANY_NAME' | translate">
                <input *ngIf="contact.person_type_fa == 'حقوقی'" class="form-control form-control-sm ltr" type="text"
                    maxlength="20" [(ngModel)]="contact.identification_no"
                    [placeholder]="('NATIONAL_ID' | translate) + ' *'">
                <input class="form-control form-control-sm ltr" type="tel" maxlength="20" [(ngModel)]="contact.mobile"
                    [placeholder]="('MOBILE' | translate) + ' *'">
                <input class="form-control form-control-sm ltr" type="tel" maxlength="20" [(ngModel)]="contact.tel"
                    [placeholder]="'TEL' | translate">
                <input class="form-control form-control-sm ltr" type="email" maxlength="120" [(ngModel)]="contact.email"
                    [placeholder]="'EMAIL' | translate">
            </ng-container>
            <input class="form-control form-control-sm" type="number" min="1" max="60" [(ngModel)]="floors"
                [placeholder]="'FLOORS' | translate">
            <textarea class="form-control form-control-sm" rows="2" maxlength="300" [(ngModel)]="address"
                [placeholder]="'ADDRESS' | translate"></textarea>
            <div *ngIf="error" class="message failed">{{ error }}</div>
            <button class="btn btn-sm btn-primary btn-block" [disabled]="loading" (click)="submit()">
                {{ 'DEDICATE_LOCATION_SUBMIT' | translate }}
            </button>
        </ng-container>
    </div>
</div>
